import { Link } from "@tanstack/react-router";

/**
 * Las tres páginas más consultadas después del hero, en la misma estética
 * limpia de la banda azul de servicios: fondo azul petróleo, texto blanco,
 * título en gris claro y tres columnas con flecha.
 */
const ACCESOS = [
  { to: "/precios" as const, nombre: "Precios", para: "Desde $950 al día" },
  { to: "/galeria-de-fotos" as const, nombre: "Fotos reales", para: "La casa y el jardín" },
  { to: "/preguntas-frecuentes" as const, nombre: "Preguntas frecuentes", para: "18 respuestas" },
];

export function AccesosRapidos({
  variant = "band",
  titulo = "Lo que más consultan las familias",
  exclude,
}: {
  variant?: "band" | "panel";
  titulo?: string;
  /** Rutas a omitir (por ejemplo, la página actual) */
  exclude?: string[];
} = {}) {
  const items = exclude?.length ? ACCESOS.filter((a) => !exclude.includes(a.to)) : ACCESOS;

  const lista = (
    <>
      <p className="text-xs font-bold uppercase tracking-wider text-ink-on-strong/70">{titulo}</p>
      <ul className="mt-2 grid gap-0 sm:grid-cols-3 sm:gap-x-8">
        {items.map((a) => (
          <li key={a.to}>
            <Link to={a.to} className="pill-link-on-strong group">
              <span>
                <span className="block font-semibold text-ink-on-strong">{a.nombre}</span>
                <span className="mt-0.5 block text-sm text-ink-on-strong/80">{a.para}</span>
              </span>
              <span aria-hidden className="pill-arrow-on-strong text-lg">
                →
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </>
  );

  if (variant === "panel") {
    return (
      <nav aria-label="Accesos rápidos" className="section-air">
        <div className="container-site">
          <div className="panel-light">
            <p className="micro-label">{titulo}</p>
            <ul className="mt-2 grid gap-0 sm:grid-cols-3 sm:gap-x-8">
              {items.map((a) => (
                <li key={a.to}>
                  <Link
                    to={a.to}
                    className="group flex min-h-12 items-baseline justify-between gap-3 border-t border-border py-3 text-left transition-colors hover:border-[color:var(--ink-brand)]"
                  >
                    <span className="min-w-0">
                      <span className="block font-semibold leading-snug text-[color:var(--ink-brand)]">
                        {a.nombre}
                      </span>
                      <span className="mt-0.5 block text-sm leading-snug text-[color:var(--ink-muted)]">
                        {a.para}
                      </span>
                    </span>
                    <span aria-hidden className="text-[color:var(--moss)] transition-transform duration-180 group-hover:translate-x-1">
                      →
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </nav>
    );
  }

  return (
    <nav aria-label="Accesos rápidos" className="bg-surface-strong text-ink-on-strong">
      <div className="container-site py-3 lg:py-4">{lista}</div>
    </nav>
  );
}
